<template>
  <div class="px-1 py-1">
    <div class="d-flex">
      <div class="title-presentation">
        <div v-if="evaluation" class="evaluation-name-title">
          {{ evaluation.title }}
        </div>
        <div
          v-if="
            showMatterLanguageBadge &&
            user &&
            !user.group_names.includes('ESTUDIANTES')
          "
          class="container-matter-language"
        >
          <span
            class="matter-language-badge noprint"
            v-b-tooltip.top.hover.v-warning.noninteractive="
              $t('reusable.common.matterLanguageAutoChanged')
            "
          >
            <img
              v-if="matterLanguageFlag"
              :src="matterLanguageFlag"
              :alt="matterLanguage.code"
              class="matter-language-badge_flag"
            />
            {{
              $t("matterProgram.matterProgramView.matterLanguageLabel", {
                entity: $getVisibleNames(
                  "mesh.egressprofilematter",
                  false,
                  "Asignatura",
                  true
                ),
              })
            }}:
            {{ matterLanguage.name }}
          </span>
        </div>
      </div>
      <ViewEvaluationGrade
        v-if="
          (evaluatee_view && isFinishTestEvaluation) ||
          (evaluator_view && selected_user)
        "
        class="grade-container"
        :user_id="evaluator_view ? selected_user : user.id"
        :evaluator_view="evaluator_view"
        :evaluatee_view="evaluatee_view"
        :evaluation_id="evaluation_id"
      ></ViewEvaluationGrade>
    </div>
    <!-- OutputFormat -->
    <!-- <div class="container-exit-format d-flex">
      <b-button
        v-if="
          allows_crud &&
          evaluation &&
          !evaluation.is_locked &&
          !preview_evaluation
            ? allows_crud
            : false
        "
        v-b-tooltip.top.noninteractive.v-secondary="
            `Formato de salida Evaluación Parcial`
          "
        variant="primary"
        size="sm"
      >
        <b-icon-pencil-square class="pencil-icon"></b-icon-pencil-square>
        (FS) Evaluación Parcial
      </b-button>
    </div> -->
    <div class="d-flex">
      <b-button
        class="noprint ml-auto mr-0"
        v-if="
          !allows_crud && !evaluatee_view && !evaluator_view && fetch_completed
        "
        @click="fullImpressionEvaluation"
        variant="primary"
        size="sm"
      >
        <div class="d-flex" style="align-items: center">
          <b-icon icon="printer" class="mr-1"></b-icon>
          <span>{{
            $t("evaluations.newEvaluations.fullEvaluationPrint")
          }}</span>
        </div>
      </b-button>
    </div>
    <SelectedEvaluatee
      v-if="evaluator_view && evaluation"
      :evaluation="evaluation"
      :actualTest="testFilter[tabIndex]"
      :evaluator_view="evaluator_view"
      @selected_user="slotEvaluateeSelected"
    ></SelectedEvaluatee>
    <div
      class="container-buttons-evaluation"
      :class="{
        'btn-preview-evaluation': preview_evaluation == true,
        'btn-preview-evaluation-no-edit': !allows_crud,
        'btn-is-locked-activate': evaluation && evaluation.is_locked,
      }"
    >
      <div>
        <ButtonMedium
          v-if="
            allows_crud &&
            evaluation &&
            !evaluation.is_locked &&
            !preview_evaluation
              ? allows_crud
              : false
          "
          :tooltip_text="``"
          :text_button="
            $t('reusable.common.editTooltip', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
            })
          "
          :click_button="
            () => $bvModal.show(`modal-edit-evaluation-${evaluation_id}`)
          "
          :icon="'square'"
          :variant="'primary'"
        >
        </ButtonMedium>
        <ButtonMedium
          v-if="
            allows_crud &&
            !preview_evaluation &&
            evaluation &&
            available_sections_to_replicate_section_evaluation.length > 1 &&
            user &&
            ['PROFESORES'].some((group) => user.group_names.includes(group)) &&
            section &&
            section.professors.includes(user.id) &&
            !evaluation.test_creation_is_locked &&
            [1].includes(evaluation.scope)
          "
          :tooltip_text="``"
          :text_button="
            $t('evaluations.newEvaluations.replicateEvaluationTo', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
              sections: $getVisibleNames('teaching.section', true, 'Secciones'),
            })
          "
          :click_button="openReplicateEvaluationInSectionEvaluation"
          :icon="'files'"
          :variant="'primary'"
          :custom_class="`ml-2`"
        >
        </ButtonMedium>
        <b-modal
          :id="`modal-redirect-to-evaluation-${evaluation_id}`"
          :title="
            $t('evaluations.newEvaluations.replicatedEvaluations', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                true,
                'Evaluaciones'
              ),
            })
          "
          @hide="
            () => {
              selected_sections_details = [];
            }
          "
          hide-footer
          size="lg"
        >
          <b-form-group
            :label="
              $t('evaluations.newEvaluations.evaluationsReplicatedInSections', {
                entity: $getVisibleNames(
                  'evaluations2.evaluation',
                  true,
                  'Evaluaciones'
                ),
              })
            "
            label-for="selected_section_evaluation_ids"
            label-cols="0"
            label-cols-sm="auto"
            label-cols-md="auto"
            class="m-0 p-0 mb-2 d-flex align-items-center"
          >
          </b-form-group>
          <template
            v-for="section_selected in selected_sections_details.replicated_sections"
          >
            <div :key="section_selected.id">
              <span
                v-b-tooltip.v-secondary.noninteractive.hover.right="{
                  title: `${$t(
                    'evaluations.newEvaluations.additionalInformationOf',
                    { entity: section_selected.section_name }
                  )}: - ${section_selected.shift__name} - ${
                    section_selected.period__name
                  } - ${section_selected.campus__name}`,
                  boundary: 'viewport',
                }"
                class="div-href"
                @click="redirectToEvaluation(section_selected.evaluation_id)"
              >
                -{{ section_selected.section_name }} -
                {{ section_selected.period__name }}
              </span>
            </div>
          </template>
          <div class="d-flex">
            <b-button
              class="ml-auto mr-0"
              size="sm"
              @click="
                $bvModal.hide(`modal-redirect-to-evaluation-${evaluation_id}`)
              "
            >
              {{ $t("reusable.common.close") }}
            </b-button>
          </div>
        </b-modal>
        <ButtonMedium
          v-if="
            allows_crud &&
            !preview_evaluation &&
            evaluation &&
            available_sections_to_replicate_evaluation.length > 1 &&
            !evaluation.test_creation_is_locked &&
            [2, 3].includes(evaluation.scope)
          "
          :tooltip_text="``"
          :text_button="
            $t('evaluations.newEvaluations.updateEvaluationInCreatedSections', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
              sections: $getVisibleNames('teaching.section', true, 'Secciones'),
            })
          "
          :click_button="openReplicateEvaluationInSection"
          :icon="'files'"
          :variant="'primary'"
          :custom_class="`ml-2`"
        >
        </ButtonMedium>
      </div>
      <b-modal
        v-if="evaluation"
        :id="`modal-copy-evaluation-in-section-${evaluation.id}`"
        @hide="
          () => {
            selected_section_ids = [];
          }
        "
        hide-footer
        size="lg"
      >
        <template #modal-title>
          <div class="d-flex">
            {{
              $t(
                "evaluations.newEvaluations.updateEvaluationInCreatedSections",
                {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  ),
                  sections: $getVisibleNames(
                    "teaching.section",
                    true,
                    "Secciones"
                  ),
                }
              )
            }}
            <InfoModal
              class="ml-1"
              :b_modal_ref="'replicate-evaluation-color-description'"
              :tooltip_text="
                $t('evaluations.newEvaluations.pressToViewColorMeaning', {
                  entity: $getVisibleNames(
                    'teaching.section',
                    true,
                    'Secciones'
                  ),
                })
              "
              :modal_title="
                $t('evaluations.newEvaluations.colorInformationFor', {
                  entity: $getVisibleNames(
                    'teaching.section',
                    true,
                    'Secciones'
                  ),
                })
              "
            >
              <b-table-simple fixed hover bordered small>
                <b-thead>
                  <b-th class="th-class text-center" style="width: 85px">
                    {{ $t("reusable.common.color").toUpperCase() }}
                  </b-th>
                  <b-th class="th-class">{{
                    $t("reusable.common.description").toUpperCase()
                  }}</b-th>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-td>
                      <b-badge style="background-color: green" class="w-100"
                        >&nbsp;</b-badge
                      >
                    </b-td>
                    <b-td>{{
                      $t(
                        "evaluations.newEvaluations.indicatesNotExistsCanReplicate"
                      )
                    }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>
                      <b-badge style="background-color: red" class="w-100"
                        >&nbsp;</b-badge
                      >
                    </b-td>
                    <b-td>{{
                      $t(
                        "evaluations.newEvaluations.indicatesExistsCannotReplicate",
                        {
                          entity: $getVisibleNames(
                            "evaluations2.test",
                            true,
                            "instrumentos"
                          ),
                        }
                      )
                    }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </InfoModal>
          </div>
        </template>
        <b-form-group
          :label="
            $t('evaluations.newEvaluations.selectSectionsToUpdate', {
              entity: $getVisibleNames(
                'teaching.section',
                true,
                'Secciones'
              ).toLowerCase(),
            })
          "
          label-for="selected_section_ids2"
          label-cols="0"
          label-cols-sm="auto"
          label-cols-md="auto"
          class="m-0 p-0 mb-2"
        >
          <v-select
            class="mt-1"
            id="selected_section_ids2"
            :placeholder="
              $t('evaluations.newEvaluations.selectOneOrMoreToFilter')
            "
            track-by="id"
            label="name"
            size="sm"
            v-model="selected_section_ids"
            :options="sortedAvailableSections"
            :reduce="(s) => s.id"
            :disabled="!allows_crud"
            :dropdown-should-open="dropdownShouldOpen2"
            multiple
            :selectable="
              (option) =>
                !selected_section_ids.includes(option.id) &&
                !option.evaluation_exists
            "
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                >.
              </template>
            </template>

            <!-- Opciones en el dropdown -->
            <template v-slot:option="item">
              <div v-if="item.id == 'all'">
                <span>{{ item.name }}</span>
              </div>
              <div
                v-else-if="!selected_section_ids.includes(item.id)"
                v-b-tooltip.v-secondary.noninteractive.hover.right="{
                  title: `${$t(
                    'evaluations.newEvaluations.additionalInformationOf',
                    { entity: item.name }
                  )}: - ${item.shift__name} - ${item.period__name} - ${
                    item.campus__name
                  }`,
                  boundary: 'viewport',
                }"
              >
                <b-badge
                  :style="`${
                    item.evaluation_exists == false
                      ? 'background-color: green'
                      : 'background-color: red'
                  }`"
                >
                  {{ item.name }} - {{ item.period__name }}
                </b-badge>
              </div>
              <div v-else>
                <b-badge
                  :style="`${
                    item.evaluation_exists == false
                      ? 'background-color: green'
                      : 'background-color: red'
                  }`"
                >
                  {{ item.name }} - {{ item.period__name }}
                </b-badge>
              </div>
            </template>

            <!-- Tags seleccionados con tooltip y color -->
            <template v-slot:selected-option="item">
              <b-badge
                :style="`${
                  item.evaluation_exists == false
                    ? 'background-color: green'
                    : 'background-color: red'
                }`"
                v-b-tooltip.v-secondary.noninteractive.hover="{
                  title: `${$t(
                    'evaluations.newEvaluations.additionalInformationOf',
                    { entity: item.name }
                  )}: - ${item.shift__name} - ${item.period__name} - ${
                    item.campus__name
                  }`,
                  boundary: 'viewport',
                }"
              >
                {{ item.name }}
              </b-badge>
            </template>
          </v-select>
        </b-form-group>
        <div class="d-flex">
          <b-button
            class="ml-auto mr-0"
            size="sm"
            @click="replicateEvaluationInSection"
            :disabled="
              selected_section_ids.length == 0 || disable_replicate_buttons
            "
          >
            {{ $t("reusable.common.apply") }}
          </b-button>
        </div>
      </b-modal>
      <b-modal
        v-if="evaluation"
        :id="`modal-redirect-to-evaluation-updated-${evaluation.id}`"
        :title="
          $t('evaluations.newEvaluations.replicatedEvaluationsFeminine', {
            entity: $getVisibleNames(
              'evaluations2.evaluation',
              true,
              'Evaluación'
            ),
          })
        "
        hide-footer
        size="lg"
      >
        <b-form-group
          :label="
            $t('evaluations.newEvaluations.evaluationUpdatedInSection', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
            })
          "
          label-for="selected_evaluations_ids"
          label-cols="0"
          label-cols-sm="auto"
          label-cols-md="auto"
          class="m-0 p-0 mb-2 d-flex align-items-center"
        >
        </b-form-group>
        <template v-if="replication_response">
          <div v-if="replication_response.recreated.length > 0">
            <strong>
              {{
                $getVisibleNames("evaluations2.evaluation", false, "Evaluación")
              }}
              {{ $t("evaluations.newEvaluations.recreated") }}:
            </strong>
            <span
              v-for="(item, index) in replication_response.recreated"
              :key="`deleted-${index}`"
            >
              <span
                @click="redirectToEvaluation(item.evaluation_id)"
                class="div-href"
                v-b-tooltip.v-secondary.noninteractive.hover="{
                  title: $t('evaluations.newEvaluations.goToEntity', {
                    entity: $getVisibleNames(
                      'evaluations2.evaluation',
                      false,
                      'Evaluación'
                    ),
                  }),
                  boundary: 'viewport',
                }"
              >
                {{ getSectionName(item.section_id) }}</span
              ><span v-if="index < replication_response.recreated.length - 1"
                >,
              </span>
            </span>
          </div>
        </template>
        <div class="d-flex">
          <b-button
            class="ml-auto mr-0"
            size="sm"
            @click="
              $bvModal.hide(
                `modal-redirect-to-evaluation-updated-${evaluation.id}`
              )
            "
          >
            {{ $t("reusable.common.close") }}
          </b-button>
        </div>
      </b-modal>
      <b-modal
        v-if="evaluation"
        :id="`modal-copy-evaluation-in-section-evaluation-${evaluation.id}`"
        @hide="
          () => {
            selected_section_evaluation_ids = [];
          }
        "
        hide-footer
        size="lg"
      >
        <template #modal-title>
          <div class="d-flex">
            {{
              $t(
                "evaluations.newEvaluations.replicateEvaluationInOtherSections",
                {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  ),
                  sections: $getVisibleNames(
                    "teaching.section",
                    true,
                    "Secciones"
                  ),
                  subject: $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  ),
                }
              )
            }}
          </div>
        </template>
        <b-form-group
          :label="
            $t('evaluations.newEvaluations.selectSectionsToReplicate', {
              entity: $getVisibleNames(
                'teaching.section',
                true,
                'Secciones'
              ).toLowerCase(),
            })
          "
          label-for="selected_section_evaluation_ids"
          label-cols="0"
          label-cols-sm="auto"
          label-cols-md="auto"
          class="m-0 p-0 mb-2"
        >
          <v-select
            class="mt-1"
            id="selected_section_evaluation_ids"
            :placeholder="
              $t('evaluations.newEvaluations.selectOneOrMoreToFilter')
            "
            track-by="id"
            label="name"
            size="sm"
            v-model="selected_section_evaluation_ids"
            :options="available_sections_to_replicate_section_evaluation"
            :reduce="(s) => s.id"
            :disabled="!allows_crud"
            :dropdown-should-open="dropdownShouldOpen3"
            multiple
            :selectable="
              (option) => !selected_section_evaluation_ids.includes(option.id)
            "
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                {{ $t("reusable.common.noOptions") }} <em>{{ search }}</em
                >.
              </template>
            </template>

            <!-- Opciones en el dropdown -->
            <template v-slot:option="item">
              <div v-if="item.id == 'all'">
                <span>{{ item.name }}</span>
              </div>
              <div
                v-else-if="!selected_section_evaluation_ids.includes(item.id)"
                v-b-tooltip.v-secondary.noninteractive.hover.right="{
                  title: `${$t(
                    'evaluations.newEvaluations.additionalInformationOf',
                    { entity: item.name }
                  )}: - ${item.shift__name} - ${item.period__name} - ${
                    item.campus__name
                  }`,
                  boundary: 'viewport',
                }"
              >
                <b-badge> {{ item.name }} - {{ item.period__name }} </b-badge>
              </div>
              <div v-else>
                <b-badge> {{ item.name }} - {{ item.period__name }} </b-badge>
              </div>
            </template>

            <!-- Tags seleccionados con tooltip y color -->
            <template v-slot:selected-option="item">
              <b-badge
                v-b-tooltip.v-secondary.noninteractive.hover="{
                  title: `${$t(
                    'evaluations.newEvaluations.additionalInformationOf',
                    { entity: item.name }
                  )}: - ${item.shift__name} - ${item.period__name} - ${
                    item.campus__name
                  }`,
                  boundary: 'viewport',
                }"
              >
                {{ item.name }}
              </b-badge>
            </template>
          </v-select>
        </b-form-group>
        <div class="d-flex">
          <b-button
            class="ml-auto mr-0"
            size="sm"
            @click="replicateEvaluationInSectionEvaluation"
            :disabled="
              selected_section_evaluation_ids.length == 0 ||
              disable_replicate_buttons
            "
          >
            {{ $t("reusable.common.apply") }}
          </b-button>
        </div>
      </b-modal>
      <!-- <b-button
        v-if="
          allows_crud &&
          evaluation &&
          !evaluation.is_locked &&
          !preview_evaluation
            ? allows_crud
            : false
        "
        variant="primary"
        size="sm"
        @click="$bvModal.show(`modal-edit-evaluation-${evaluation_id}`)"
      >
        <b-icon-pencil-square class="pencil-icon"></b-icon-pencil-square>
        Editar
        {{ $getVisibleNames("evaluations2.evaluation", false, "Evaluación") }}
      </b-button> -->
      <div>
        <ButtonMedium
          v-if="
            evaluation &&
            !evaluation.is_locked &&
            allows_crud &&
            user &&
            !user.group_names.includes('PROFESORES') &&
            !preview_evaluation
          "
          :tooltip_text="
            $t('evaluations.newEvaluations.lockEntity', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
            })
          "
          :text_button="``"
          :click_button="changeStateEvaluation"
          :icon="'unlock'"
          :variant="'primary'"
          :custom_class="`mr-2`"
        >
        </ButtonMedium>
        <!-- <b-button
          v-if="
            evaluation &&
            !evaluation.is_locked &&
            allows_crud &&
            user &&
            !user.groups.includes(6) &&
            !preview_evaluation
          "
          variant="primary"
          size="sm"
          class="lock-btn p-0 mr-2 noprint"
          v-b-tooltip.top.noninteractive.v-secondary="
            `Bloquear  ${$getVisibleNames(
              'evaluations2.evaluation',
              false,
              'Evaluación'
            )}`
          "
          @click="changeStateEvaluation()"
        >
          <b-icon-unlock-fill></b-icon-unlock-fill>
        </b-button> -->
        <ButtonMedium
          v-if="
            evaluation &&
            evaluation.is_locked &&
            allows_crud &&
            user &&
            !user.group_names.includes('PROFESORES') &&
            !preview_evaluation
          "
          :tooltip_text="
            $t('evaluations.newEvaluations.unlockEntity', {
              entity: $getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Evaluación'
              ),
            })
          "
          :text_button="``"
          :click_button="changeStateEvaluation"
          :icon="'lock'"
          :variant="'primary'"
          :custom_class="`mr-2`"
        >
        </ButtonMedium>
        <!-- <b-button
          v-if="
            evaluation &&
            evaluation.is_locked &&
            allows_crud &&
            user &&
            !user.groups.includes(6) &&
            !preview_evaluation
          "
          variant="primary"
          size="sm"
          class="lock-btn p-0 mr-2 noprint"
          v-b-tooltip.top.noninteractive.v-secondary="
            `Desbloquear  ${$getVisibleNames(
              'evaluations2.evaluation',
              false,
              'Evaluación'
            )}`
          "
          @click="changeStateEvaluation()"
        >
          <b-icon-lock-fill></b-icon-lock-fill>
        </b-button> -->
        <ButtonMedium
          v-if="testFilter.length > 0 && !evaluatee_view && !evaluator_view"
          :tooltip_text="``"
          :text_button="
            !preview_evaluation
              ? $t('evaluations.newEvaluations.viewAsStudent')
              : $t('evaluations.newEvaluations.viewAsTeacher')
          "
          :click_button="previewEvaluation"
          :icon="''"
          :variant="'primary'"
          :custom_class="`mr-2`"
        >
        </ButtonMedium>
        <!-- <b-button
          v-if="testFilter.length > 0 && !evaluatee_view && !evaluator_view"
          class="noprint"
          variant="primary"
          size="sm"
          @click="previewEvaluation"
        >
          {{
            !preview_evaluation ? "Ver como Estudiante" : "Ver como Profesor"
          }}
        </b-button> -->
      </div>
    </div>
    <b-modal
      :id="`modal-edit-evaluation-${evaluation_id}`"
      :title="
        $t('reusable.common.editTooltip', {
          entity: $getVisibleNames(
            'evaluations2.evaluation',
            false,
            'Evaluación'
          ),
        })
      "
      hide-footer
      size="xl"
      v-if="evaluation"
    >
      <NewEvaluationForm
        :Evaluation="evaluation"
        :evaluation_scoped_id="evaluation.scope"
        :evaluation_scoped_object_id="evaluation.scope_id"
        :Sections="sections"
        :Matters="matters"
        :show_step="
          evaluation &&
          (evaluation.matter_evaluation != null ||
            evaluation.egress_profile_matter_evaluation != null ||
            evaluation.scope == 1)
        "
        :EgressProfileMatters="egress_profile_matters"
        :ClosedEvaluatee="existEvaluateeEvaluation"
        @closeModal="$bvModal.hide(`modal-edit-evaluation-${evaluation_id}`)"
      ></NewEvaluationForm>
    </b-modal>
    <!-- OutputFormat -->
    <HeaderOutputFormat
      v-if="matter_evaluation != null"
      :class="{
        'd-none':
          !isfullImpressionEvaluation &&
          !isPrintingRubrica &&
          !isPrintingInstrumento &&
          !first_format_written_exam_duoc &&
          !second_format_written_exam_duoc &&
          !third_format_epe_duoc &&
          !fourth_format_epe_duoc &&
          !fifth_format_correct_answer_rubric_duoc &&
          !sixth_format_formative_duoc &&
          !seventh_format_eva_partial_duoc &&
          !eighth_format_eva_partial_duoc &&
          !nineth_format_written_partial_duoc &&
          !tenth_format_written_partial_duoc,
      }"
      :evaluation_id="evaluation_id"
      :time_output_format="matter_evaluation"
      :sixth_format_formative_duoc="sixth_format_formative_duoc"
    ></HeaderOutputFormat>
    <HeaderEvaluation
      :class="{
        'd-none':
          (isPrintingRubrica ||
            isPrintingInstrumento ||
            isfullImpressionEvaluation ||
            first_format_written_exam_duoc ||
            second_format_written_exam_duoc ||
            third_format_epe_duoc ||
            fourth_format_epe_duoc ||
            fifth_format_correct_answer_rubric_duoc ||
            sixth_format_formative_duoc ||
            seventh_format_eva_partial_duoc ||
            eighth_format_eva_partial_duoc ||
            nineth_format_written_partial_duoc ||
            tenth_format_written_partial_duoc) &&
          matter_evaluation != null,
      }"
      :evaluation_id="evaluation_id"
      :allows_crud="
        allows_crud &&
        evaluation &&
        !evaluation.is_locked &&
        !preview_evaluation
          ? allows_crud
          : false
      "
      :evaluatee_view="evaluatee_view"
    ></HeaderEvaluation>

    <b-card
      :class="{ 'print-hide': isfullImpressionEvaluation == true }"
      class="container-instrument mt-4"
      no-body
    >
      <b-tabs
        v-model="tabIndex"
        class="pt-2"
        active-nav-item-class="font-weight-bold"
        :no-nav-style="
          isPrintingRubrica ||
          isPrintingInstrumento ||
          first_format_written_exam_duoc ||
          second_format_written_exam_duoc ||
          third_format_epe_duoc ||
          fourth_format_epe_duoc ||
          fifth_format_correct_answer_rubric_duoc ||
          sixth_format_formative_duoc ||
          seventh_format_eva_partial_duoc ||
          eighth_format_eva_partial_duoc ||
          nineth_format_written_partial_duoc ||
          tenth_format_written_partial_duoc
        "
      >
        <b-tab v-for="(test, index) in testFilter" :key="test.id">
          <template #title>
            <div
              :class="{
                'print-hide':
                  isPrintingRubrica ||
                  isPrintingInstrumento ||
                  first_format_written_exam_duoc ||
                  second_format_written_exam_duoc ||
                  third_format_epe_duoc ||
                  fourth_format_epe_duoc ||
                  fifth_format_correct_answer_rubric_duoc ||
                  sixth_format_formative_duoc ||
                  seventh_format_eva_partial_duoc ||
                  eighth_format_eva_partial_duoc ||
                  nineth_format_written_partial_duoc ||
                  tenth_format_written_partial_duoc,
              }"
            >
              <span>
                <b-icon-chevron-down
                  v-if="tabIndex == index"
                  style="width: 1rem; height: 1rem"
                  variant="primary"
                  class="noprint spinner-tab"
                ></b-icon-chevron-down>
                {{ test.title }}
              </span>
              <span
                v-if="
                  evaluator_view &&
                  selected_user != null &&
                  evaluateeTestScore(test.id) != null
                "
              >
                <span
                  v-b-tooltip.top.noninteractive.v-secondary="
                    $t('evaluations.newEvaluations.assignedScore')
                  "
                  >( {{ evaluateeTestScore(test.id) }}</span
                >
                /
                {{ test.max_score }} )
              </span>
            </div>
          </template>
          <template
            v-if="
              openTabsIndex.includes(index) ||
              evaluator_view ||
              (!evaluator_view && !evaluatee_view)
            "
          >
            <ContainerInstrument
              class="pl-1 pr-1"
              v-if="
                !evaluator_view ||
                (evaluator_view &&
                  (evaluator_check_section ||
                    evaluator_check_evaluation ||
                    evaluator_check_tests))
              "
              :container_instrument_id="'upper_container_instrument'"
              :key="key_evaluation_criteria"
              :test="test"
              :key_evaluation_criteria="key_evaluation_criteria"
              :allows_crud="allows_crud"
              :evaluation_id="evaluation_id"
              :evaluatee_view="evaluatee_view"
              :evaluator_view="evaluator_view"
              :isPrintingRubrica="isPrintingRubrica"
              :isPrintingInstrumento="isPrintingInstrumento"
              :preview_evaluation="preview_evaluation"
              :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
              :user_id="selected_user"
              :evaluation_situations="evaluation_situations"
              :matter_evaluation="matter_evaluation"
              :first_format_written_exam_duoc="first_format_written_exam_duoc"
              :second_format_written_exam_duoc="second_format_written_exam_duoc"
              :third_format_epe_duoc="third_format_epe_duoc"
              :fourth_format_epe_duoc="fourth_format_epe_duoc"
              :fifth_format_correct_answer_rubric_duoc="
                fifth_format_correct_answer_rubric_duoc
              "
              :sixth_format_formative_duoc="sixth_format_formative_duoc"
              :seventh_format_eva_partial_duoc="seventh_format_eva_partial_duoc"
              :eighth_format_eva_partial_duoc="eighth_format_eva_partial_duoc"
              :nineth_format_written_partial_duoc="
                nineth_format_written_partial_duoc
              "
              :tenth_format_written_partial_duoc="
                tenth_format_written_partial_duoc
              "
              @change_preview_evaluation="previewEvaluation"
              @print_instrument="printInstrument"
              @print_rubric="printRubric"
              @previous_tabs="() => tabIndex--"
              @next_tabs="() => tabIndex++"
              @finished_test="goToNextPendingInstrument"
              @is_fetch_completed="isFetchCompleted"
            >
              <template #formatter-duoc>
                <!-- Nuevos Formatos de Salida -->
                <div
                  v-if="
                    fetch_completed &&
                    !allows_crud &&
                    institution &&
                    institution.internal_use_id == 'duoc.cl'
                  "
                  class="container-new-documents ml-2 mt-3 noprint"
                >
                  <!-- Formato 1. ET Prueba Escrita Docente -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 4 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_escrita_preguntas_abiertas_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.teacherInstructions')
                    "
                    :click_button="firstFormatWrittenExamDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 2. ET Prueba Escrita Estudiantes -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 4 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_escrita_preguntas_abiertas_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.studentInstructions')
                    "
                    :click_button="secondFormatWrittenExamDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 3. ET Instrucciones y Pauta Docente (Encargo, Presentación, Ejecución práctica) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 4 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_ejecucion_practica_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_entrega_de_encargo_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_presentacion_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t(
                        'evaluations.newEvaluations.instructionsAndGuidelineTeacher'
                      )
                    "
                    :click_button="thirdFormatEPEDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 4. ET Instrucciones y Pauta Estudiante (Encargo, Presentación, Ejecución práctica) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 4 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_ejecucion_practica_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_entrega_de_encargo_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_presentacion_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t(
                        'evaluations.newEvaluations.instructionsAndGuidelineStudent'
                      )
                    "
                    :click_button="fourthFormatEPEDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 5. ET Claves de Respuestas o Rubrica -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 4 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_escrita_preguntas_abiertas_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test'
                        ? $t('evaluations.newEvaluations.rubric')
                        : evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test'
                        ? $t('evaluations.newEvaluations.answerKeys')
                        : ''
                    "
                    :click_button="fifthFormatEPEDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 6. Evaluacion Formativa -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 3 &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.teacherFormat')
                    "
                    :click_button="sixthFormatFormativeDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 7. Evaluacion Parcial/Sumativa para el Docente (Encargo, Presentación, Ejecución práctica) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 1 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_ejecucion_practica_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_entrega_de_encargo_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_presentacion_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.teacherFormat')
                    "
                    :click_button="seventhFormatEvaPartialDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 8. Evaluacion Parcial/Sumativa para el Estudiante (Encargo, Presentación, Ejecución práctica) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 1 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_ejecucion_practica_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_entrega_de_encargo_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_presentacion_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.studentFormat')
                    "
                    :click_button="eighthFormatEvaPartialDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 9. Evaluacion Parcial/Sumativa para el Docente (Prueba Escrita) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 1 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_escrita_preguntas_abiertas_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      $t('evaluations.newEvaluations.teacherFormat')
                    "
                    :click_button="ninethFormatWrittenPartialDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>

                  <!-- Formato 10. Evaluacion Parcial/Sumativa para el Estudiante (Prueba Escrita) -->
                  <ButtonMedium
                    v-if="
                      evaluation &&
                      evaluation.type == 1 &&
                      evaluationSituation(test) &&
                      (evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_escrita_preguntas_abiertas_test' ||
                        evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test') &&
                      !allows_crud &&
                      !evaluatee_view &&
                      !evaluator_view &&
                      user &&
                      !user.group_names.includes('ESTUDIANTES')
                    "
                    :tooltip_text="``"
                    :text_button="
                      evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test'
                        ? $t('evaluations.newEvaluations.rubric')
                        : evaluationSituation(test).internal_use_id ==
                          'duoc_prueba_seleccion_multiple_test'
                        ? $t('evaluations.newEvaluations.answerKeys')
                        : ''
                    "
                    :click_button="tenthFormatWrittenPartialDuoc"
                    :icon="'printer'"
                    :variant="'primary'"
                    :custom_class="`mr-2`"
                  >
                  </ButtonMedium>
                </div>
              </template>
            </ContainerInstrument>
          </template>
        </b-tab>
        <!-- Botón Agregar nuevo Instrumento -->
        <template
          v-if="
            allows_crud &&
            evaluation &&
            !preview_evaluation &&
            !evaluation.test_creation_is_locked
          "
          #tabs-start
        >
          <div class="container-add-instrument">
            <ButtonMedium
              :tooltip_text="``"
              :text_button="
                $t('reusable.common.addTooltip', {
                  entity: $getVisibleNames(
                    'evaluations2.test',
                    false,
                    'Instrumento'
                  ),
                })
              "
              :click_button="() => $bvModal.show(`modal-created-instrument`)"
              :icon="'plus'"
              :variant="'primary'"
            >
            </ButtonMedium>
            <!-- <b-button
              variant="primary"
              size="sm"
              @click="$bvModal.show(`modal-created-instrument`)"
              class="link-span add-new-instrument ml-0"
            >
              + Agregar
              {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
            </b-button> -->
          </div>
        </template>

        <!-- Renderizado si no hay tabs -->
        <template #empty>
          <div class="text-center text-muted">
            <template v-if="evaluatee_view">
              {{
                $t(
                  "evaluations.newEvaluations.noInstrumentAvailableForEvaluatee",
                  {
                    entity: $getVisibleNames(
                      "evaluations2.test",
                      false,
                      "Instrumento"
                    ),
                  }
                )
              }}
            </template>
            <template v-else-if="evaluator_view">
              {{
                $t(
                  "evaluations.newEvaluations.noInstrumentAvailableForEvaluator",
                  {
                    entity: $getVisibleNames(
                      "evaluations2.test",
                      false,
                      "Instrumento"
                    ),
                  }
                )
              }}
            </template>
            <template v-else>
              {{
                $t("evaluations.newEvaluations.noInstrumentCreated", {
                  entity: $getVisibleNames(
                    "evaluations2.test",
                    false,
                    "Instrumento"
                  ),
                })
              }}<br />
              {{
                $t("evaluations.newEvaluations.toCreateNewInstrument", {
                  entity: $getVisibleNames(
                    "evaluations2.test",
                    false,
                    "Instrumento"
                  ),
                })
              }}
            </template>
          </div>
        </template>
      </b-tabs>
    </b-card>
    <div
      v-if="!evaluator_view && !evaluatee_view"
      :class="{ 'd-none': !isfullImpressionEvaluation }"
    >
      <div v-for="(test, index) in testFilter" :key="test.id">
        <div :class="{ 'page-break': index != 0 }">
          <h3 class="mt-4">
            {{ test.title }}
          </h3>
          <ContainerInstrument
            v-if="
              !evaluator_view ||
              (evaluator_view &&
                (evaluator_check_section ||
                  evaluator_check_evaluation ||
                  evaluator_check_tests))
            "
            :container_instrument_id="'down_container_instrument'"
            :key="key_evaluation_criteria"
            :test="test"
            :key_evaluation_criteria="key_evaluation_criteria"
            :allows_crud="allows_crud"
            :evaluation_id="evaluation_id"
            :evaluatee_view="evaluatee_view"
            :evaluator_view="evaluator_view"
            :isPrintingRubrica="isPrintingRubrica"
            :isPrintingInstrumento="isPrintingInstrumento"
            :preview_evaluation="preview_evaluation"
            :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
            :user_id="selected_user"
            :requests_within_the_component="false"
            :evaluation_situations="evaluation_situations"
            :matter_evaluation="matter_evaluation"
            :first_format_written_exam_duoc="first_format_written_exam_duoc"
            :second_format_written_exam_duoc="second_format_written_exam_duoc"
            :third_format_epe_duoc="third_format_epe_duoc"
            :fourth_format_epe_duoc="fourth_format_epe_duoc"
            :fifth_format_correct_answer_rubric_duoc="
              fifth_format_correct_answer_rubric_duoc
            "
            :sixth_format_formative_duoc="sixth_format_formative_duoc"
            :seventh_format_eva_partial_duoc="seventh_format_eva_partial_duoc"
            :eighth_format_eva_partial_duoc="eighth_format_eva_partial_duoc"
            :nineth_format_written_partial_duoc="
              nineth_format_written_partial_duoc
            "
            :tenth_format_written_partial_duoc="
              tenth_format_written_partial_duoc
            "
            @change_preview_evaluation="previewEvaluation"
            @print_instrument="printInstrument"
            @print_rubric="printRubric"
            @previous_tabs="() => tabIndex--"
            @next_tabs="() => tabIndex++"
          >
            <template #formatter-duoc>
              <!-- Nuevos Formatos de Salida -->
              <div
                v-if="
                  fetch_completed &&
                  !allows_crud &&
                  institution &&
                  institution.internal_use_id == 'duoc.cl'
                "
                class="container-new-documents ml-2 mt-3 noprint"
              >
                <!-- Formato 1. ET Prueba Escrita Docente -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 4 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    $t('evaluations.newEvaluations.teacherInstructions')
                  "
                  :click_button="firstFormatWrittenExamDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 2. ET Prueba Escrita Estudiantes -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 4 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    $t('evaluations.newEvaluations.studentInstructions')
                  "
                  :click_button="secondFormatWrittenExamDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 3. ET Instrucciones y Pauta Docente (Encargo, Presentación, Ejecución práctica) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 4 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_ejecucion_practica_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_entrega_de_encargo_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_presentacion_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    $t(
                      'evaluations.newEvaluations.instructionsAndGuidelineTeacher'
                    )
                  "
                  :click_button="thirdFormatEPEDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 4. ET Instrucciones y Pauta Estudiante (Encargo, Presentación, Ejecución práctica) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 4 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_ejecucion_practica_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_entrega_de_encargo_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_presentacion_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    $t(
                      'evaluations.newEvaluations.instructionsAndGuidelineStudent'
                    )
                  "
                  :click_button="fourthFormatEPEDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 5. ET Claves de Respuestas o Rubrica -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 4 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    evaluationSituation(test).internal_use_id ==
                    'duoc_prueba_escrita_preguntas_abiertas_test'
                      ? $t('evaluations.newEvaluations.rubric')
                      : evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test'
                      ? $t('evaluations.newEvaluations.answerKeys')
                      : ''
                  "
                  :click_button="fifthFormatEPEDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 6. Evaluacion Formativa -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 3 &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="$t('evaluations.newEvaluations.teacherFormat')"
                  :click_button="sixthFormatFormativeDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 7. Evaluacion Parcial/Sumativa para el Docente (Encargo, Presentación, Ejecución práctica) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 1 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_ejecucion_practica_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_entrega_de_encargo_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_presentacion_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="$t('evaluations.newEvaluations.teacherFormat')"
                  :click_button="seventhFormatEvaPartialDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 8. Evaluacion Parcial/Sumativa para el Estudiante (Encargo, Presentación, Ejecución práctica) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 1 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_ejecucion_practica_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_entrega_de_encargo_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_presentacion_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="$t('evaluations.newEvaluations.studentFormat')"
                  :click_button="eighthFormatEvaPartialDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 9. Evaluacion Parcial/Sumativa para el Docente (Prueba Escrita) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 1 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="$t('evaluations.newEvaluations.teacherFormat')"
                  :click_button="ninethFormatWrittenPartialDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>

                <!-- Formato 10. Evaluacion Parcial/Sumativa para el Estudiante (Prueba Escrita) -->
                <ButtonMedium
                  v-if="
                    evaluation &&
                    evaluation.type == 1 &&
                    evaluationSituation(test) &&
                    (evaluationSituation(test).internal_use_id ==
                      'duoc_prueba_escrita_preguntas_abiertas_test' ||
                      evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test') &&
                    !allows_crud &&
                    !evaluatee_view &&
                    !evaluator_view &&
                    user &&
                    !user.group_names.includes('ESTUDIANTES')
                  "
                  :tooltip_text="``"
                  :text_button="
                    evaluationSituation(test).internal_use_id ==
                    'duoc_prueba_escrita_preguntas_abiertas_test'
                      ? $t('evaluations.newEvaluations.rubric')
                      : evaluationSituation(test).internal_use_id ==
                        'duoc_prueba_seleccion_multiple_test'
                      ? $t('evaluations.newEvaluations.answerKeys')
                      : ''
                  "
                  :click_button="tenthFormatWrittenPartialDuoc"
                  :icon="'printer'"
                  :variant="'primary'"
                  :custom_class="`mr-2`"
                >
                </ButtonMedium>
              </div>
            </template>
          </ContainerInstrument>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <b-modal
      :id="`modal-created-instrument`"
      :title="
        $t('reusable.common.createTooltip', {
          entity: $getVisibleNames('evaluations2.test', false, 'Instrumento'),
        })
      "
      @hide="confirmClose"
      hide-footer
      size="xl"
    >
      <NewInstrumentForm
        :evaluation_id="evaluation_id"
        :show_step="
          evaluation &&
          (evaluation.matter_evaluation != null ||
            evaluation.egress_profile_matter_evaluation != null)
        "
        :Section="section"
        @change_evaluation_form="() => (change_evaluation_form = true)"
        @closeModal="createdInstrument"
      ></NewInstrumentForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const LANGUAGE_FLAG_MAP = {
  es: require("@/assets/es_icon.png"),
  en: require("@/assets/us_icon.png"),
};

export default {
  name: "NewEvaluation",
  components: {
    vSelect,
    HeaderEvaluation: () => import("./HeaderEvaluation"),
    HeaderOutputFormat: () =>
      import("@/components/new-evaluations/Evaluation/HeaderOutputFormat"),
    ContainerInstrument: () => import("./ContainerInstrument"),
    ViewEvaluationGrade: () => import("./ViewEvaluationGrade"),
    NewInstrumentForm: () => import("./NewInstrumentForm"),
    SelectedEvaluatee: () => import("./Evaluators/SelectedEvaluatee"),
    NewEvaluationForm: () =>
      import(
        "@/components/new-evaluations/ManageEvaluations/NewEvaluationForm"
      ),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    InfoModal: () => import("@/components/reusable/InfoModal"),
  },
  props: {
    evaluation_id: {
      type: Number,
      required: true,
    },
    instrument_id: {
      type: Number,
    },
    evaluatee_view: {
      type: Boolean,
      default: false,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
    allows_crud: {
      type: Boolean,
    },
  },
  data() {
    return {
      sections: [],
      matters: [],
      egress_profile_matters: [],
      tabIndex: -1,
      openTabsIndex: [],
      evaluation_criteria_micro_ids: [],
      matter_evaluation: null,
      key_evaluation_criteria: 0,
      preview_evaluation:
        this.evaluatee_view || this.evaluator_view ? true : false,
      isfullImpressionEvaluation: false,
      isPrintingRubrica: false,
      isPrintingInstrumento: false,
      selected_user: null,
      // view_output_format: null,
      evaluator_check_section: true,
      evaluator_check_evaluation: true,
      evaluator_check_tests: true,
      evaluation_situations: [],
      fetch_completed: false,
      prevent_close_modal: false,
      change_evaluation_form: false,
      //Nuevos formatos de salida Duoc
      first_format_written_exam_duoc: false,
      second_format_written_exam_duoc: false,
      third_format_epe_duoc: false,
      fourth_format_epe_duoc: false,
      fifth_format_correct_answer_rubric_duoc: false,
      sixth_format_formative_duoc: false,
      seventh_format_eva_partial_duoc: false,
      eighth_format_eva_partial_duoc: false,
      nineth_format_written_partial_duoc: false,
      tenth_format_written_partial_duoc: false,
      available_sections_to_replicate_evaluation: [],
      available_sections_to_replicate_section_evaluation: [],
      selected_section_ids: [],
      selected_section_evaluation_ids: [],
      selected_sections_details: [],
      disable_replicate_buttons: false,
      replication_response: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      sections_store: names.SECTIONS,
      evaluations: names.NEW_EVALUATIONS,
      Tests: names.NEW_TESTS,
      evaluatee_evaluations: names.EVALUATEE_EVALUATIONS,
      evaluatee_tests: names.EVALUATEE_TESTS,
      matters_store: names.MATTERS,
      egress_profile_matters_store: names.EGRESS_PROFILES_MATTERS,
      languages: names.LANGUAGES,
      matterLanguageContext: names.MATTER_LANGUAGE_CONTEXT,
    }),
    evaluation() {
      return this.evaluations.find((x) => x.id == this.evaluation_id);
    },
    // Asignatura base de la Evaluación (scope 1: Sección, 2: Asignatura del
    // Perfil de Egreso, 3: Asignatura base); ver matterLanguageMixin.
    evaluationMatter() {
      if (!this.evaluation || this.evaluation.scope_id == null) return null;
      let matter_id = null;
      if (this.evaluation.scope == 1) {
        const section = this.sections_store.find(
          (x) => x.id == this.evaluation.scope_id
        );
        if (section) {
          if (section.egress_profile_matter) {
            const egress_profile_matter =
              this.egress_profile_matters_store.find(
                (x) => x.id == section.egress_profile_matter
              );
            matter_id = egress_profile_matter
              ? egress_profile_matter.matter
              : null;
          } else if (section.matter) matter_id = section.matter;
        }
      } else if (this.evaluation.scope == 2) {
        const egress_profile_matter = this.egress_profile_matters_store.find(
          (x) => x.id == this.evaluation.scope_id
        );
        matter_id = egress_profile_matter ? egress_profile_matter.matter : null;
      } else if (this.evaluation.scope == 3)
        matter_id = this.evaluation.scope_id;
      if (!matter_id) return null;
      return this.matters_store.find((x) => x.id == matter_id) || null;
    },
    // El idioma de la asignatura solo se muestra cuando efectivamente forzó un
    // cambio de idioma en la vista (default_language != null y distinto al
    // idioma del usuario); ver matterLanguageMixin.applyMatterLanguageById.
    matterLanguage() {
      if (!this.evaluationMatter || !this.evaluationMatter.default_language)
        return null;
      return (
        this.languages.find(
          (l) => l.id === this.evaluationMatter.default_language
        ) || null
      );
    },
    matterLanguageFlag() {
      if (!this.matterLanguage) return null;
      return LANGUAGE_FLAG_MAP[this.matterLanguage.code] || null;
    },
    showMatterLanguageBadge() {
      return !!this.matterLanguageContext && !!this.matterLanguage;
    },
    filterEvaluateeTests() {
      if (this.selected_user == null) return [];
      else {
        const test_ids = this.Tests.filter(
          (x) => x.evaluation == this.evaluation_id
        ).map((x) => x.id);
        return this.evaluatee_tests.filter(
          (x) => test_ids.includes(x.test) && x.evaluatee == this.selected_user
        );
      }
    },
    isFinishTestEvaluation() {
      if (!this.evaluatee_view) return false;
      else {
        const test_ids = this.Tests.filter(
          (x) =>
            x.evaluation == this.evaluation_id &&
            x.evaluatees.includes(this.user.id) &&
            x.weighing > 0
        ).map((x) => x.id);
        const evaluatee_test = this.evaluatee_tests.filter(
          (x) =>
            x.evaluatee == this.user.id &&
            test_ids.includes(x.test) &&
            x.is_published == true
        );
        if (
          evaluatee_test.length == test_ids.length &&
          evaluatee_test.length != 0 &&
          test_ids.length != 0
        )
          return true;
        else return false;
      }
    },
    existEvaluateeEvaluation() {
      if (
        this.evaluatee_evaluations.filter(
          (x) => x.evaluation == this.evaluation_id
        ).length > 0
      )
        return true;
      else return false;
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections_store.find(
          (x) => x.id == this.evaluation.scope_id
        );
      else return null;
    },
    testFilter() {
      if (this.evaluator_view && this.selected_user != null) {
        return this.Tests.filter(
          (x) =>
            x.evaluation == this.evaluation_id &&
            x.evaluatees.includes(this.selected_user)
        );
      }
      if (this.evaluator_view && this.selected_user == null) {
        return this.Tests.filter((x) => x.evaluation == this.evaluation_id);
      } else if (this.evaluatee_view) {
        return this.Tests.filter(
          (x) =>
            x.evaluation == this.evaluation_id &&
            x.evaluatees.includes(this.user.id) &&
            x.visible_by_evaluatees &&
            x.start_time != null &&
            x.end_time != null
        );
      }
      return this.Tests.filter((x) => x.evaluation == this.evaluation_id);
    },
    sortedAvailableSections() {
      const priority = {
        false: 0,
        true: 1,
      };

      return [...this.available_sections_to_replicate_evaluation].sort(
        (a, b) => {
          // Mantener "all" siempre al principio
          if (a.id == "all") return -1;
          if (b.id == "all") return 1;
          return priority[a.evaluation_exists] - priority[b.evaluation_exists];
        }
      );
    },
  },
  methods: {
    redirectToEvaluation(evaluation_id, instrument_id = null) {
      // Cerrar ambos modales
      this.$bvModal.hide(`modal-redirect-to-evaluation-${this.evaluation.id}`);
      this.$bvModal.hide(
        `modal-copy-evaluation-in-section-evaluation-${this.evaluation.id}`
      );
      this.$bvModal.hide(
        `modal-copy-evaluation-in-section-${this.evaluation.id}`
      );

      // Redirigir a la evaluación
      const url = this.$router.resolve({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      }).href;
      window.open(url, "_blank");
    },
    getSectionName(section_id) {
      const section = this.available_sections_to_replicate_evaluation.find(
        (s) => s.id === section_id
      );
      return section ? section.name : "";
    },
    openReplicateEvaluationInSection() {
      if (this.evaluation)
        this.$bvModal.show(
          `modal-copy-evaluation-in-section-${this.evaluation.id}`
        );
    },
    openReplicateEvaluationInSectionEvaluation() {
      if (this.evaluation)
        this.$bvModal.show(
          `modal-copy-evaluation-in-section-evaluation-${this.evaluation.id}`
        );
    },
    replicateEvaluationInSection() {
      if (this.evaluation) {
        this.disable_replicate_buttons = true;
        this.$restful
          .Post(`/evaluations2/replicate_evaluation_to_sections/`, {
            evaluation: this.evaluation.id,
            sections: this.selected_section_ids,
          })
          .then((response) => {
            this.replication_response = response;
            this.key_evaluation_criteria++;
            this.fetchAvailableSectionToReplicateEvaluation();
            this.$bvModal.show(
              `modal-redirect-to-evaluation-updated-${this.evaluation.id}`
            );
            // this.$bvModal.hide(
            //   `modal-copy-evaluation-in-section-${this.evaluation.id}`
            // );
            this.disable_replicate_buttons = false;
          });
      }
    },
    replicateEvaluationInSectionEvaluation() {
      if (this.evaluation) {
        this.disable_replicate_buttons = true;
        this.$restful
          .Post(
            `/evaluations2/replicate_section_evaluation_to_other_sections/`,
            {
              evaluation_id: this.evaluation.id,
              section_ids: this.selected_section_evaluation_ids,
            }
          )
          .then((response) => {
            // Mantener solo la evaluación actual y limpiar las demás del store
            this.$store.commit(names.MUTATE_NEW_EVALUATIONS, [this.evaluation]);
            this.fetchAvailableSectionEvaluationToReplicateEvaluation();
            this.selected_sections_details = response;
            this.$bvModal.show(
              `modal-redirect-to-evaluation-${this.evaluation.id}`
            );
            // this.$bvModal.hide(
            //   `modal-copy-evaluation-in-section-evaluation-${this.evaluation.id}`
            // );
            this.key_evaluation_criteria++;
            this.disable_replicate_buttons = false;
          });
      }
    },
    dropdownShouldOpen2(VueSelect) {
      if (this.available_sections_to_replicate_evaluation.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    dropdownShouldOpen3(VueSelect) {
      if (this.available_sections_to_replicate_section_evaluation.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    evaluationSituation(test) {
      if (!test) return null;
      return this.evaluation_situations.find(
        (x) => x.id == test.evaluation_situation
      );
    },
    showCorrectAnswer(evaluation_situation) {
      return this.evaluation_situations.some(
        (x) =>
          x.id == evaluation_situation &&
          x.internal_use_id == "duoc_prueba_seleccion_multiple_test"
      );
    },
    confirmClose(bvModalEvt) {
      if (
        bvModalEvt.trigger === "headerclose" ||
        bvModalEvt.trigger === "event"
      ) {
        this.change_evaluation_form = false;
        return;
      }
      if (!this.prevent_close_modal && this.change_evaluation_form) {
        bvModalEvt.preventDefault();
        this.$bvModal
          .msgBoxConfirm(
            this.$t("evaluations.newEvaluations.sureCloseUnsavedData"),
            {
              title: this.$t("evaluations.newEvaluations.confirmationRequired"),
              size: "md",
              buttonSize: "md",
              okVariant: "warning",
              okTitle: this.$t("evaluations.newEvaluations.yesClose"),
              cancelTitle: this.$t("reusable.common.cancel"),
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
              headerClass: "text-black",
              header: {
                title: this.$t(
                  "evaluations.newEvaluations.confirmationRequired"
                ),
                class: "text-center",
              },
            }
          )
          .then((value) => {
            if (value) {
              this.prevent_close_modal = true;
              this.$bvModal.hide(bvModalEvt.componentId);
              this.$nextTick(() => {
                this.change_evaluation_form = false;
                this.prevent_close_modal = false;
              });
            }
          });
      }
    },
    evaluateeTestScore(test_id) {
      if (this.evaluator_view && this.selected_user != null) {
        let evaluatee_test = this.filterEvaluateeTests.find(
          (x) => x.test == test_id && x.evaluatee == this.selected_user
        );
        if (evaluatee_test) {
          const score =
            evaluatee_test.final_score != null
              ? evaluatee_test.final_score
              : evaluatee_test.manual_score != null
              ? evaluatee_test.manual_score
              : evaluatee_test.automated_score != null
              ? evaluatee_test.automated_score
              : 0;
          return !isNaN(this.$round(score)) ? this.$round(score) : 0;
        }
      }
      return 0;
    },
    slotEvaluateeSelected(evaluatee_id) {
      this.selected_user = evaluatee_id;
      this.key_evaluation_criteria++;
    },
    fetchMatterEvaluation(evaluation) {
      if (evaluation && evaluation.matter_evaluation) {
        this.$store
          .dispatch(names.FETCH_MATTER_EVALUATION, evaluation.matter_evaluation)
          .then((response) => {
            this.matter_evaluation = response;
            this.fetchStudyUnitAndEvaluationCriteria(response.matter);
            this.evaluation_criteria_micro_ids =
              response.evaluation_criterias_micro;
            this.key_evaluation_criteria++;
          });
      } else if (evaluation && evaluation.egress_profile_matter_evaluation) {
        this.$restful
          .Get(
            `/teaching/egress-profile-matter-evaluation/${evaluation.egress_profile_matter_evaluation}/`
          )
          .then((response) => {
            this.matter_evaluation = response;
            this.$store
              .dispatch(
                names.FETCH_EGRESS_PROFILE_MATTER,
                response.egress_profile_matter
              )
              .then((egr_matter) => {
                this.fetchStudyUnitAndEvaluationCriteria(egr_matter.matter);
                this.evaluation_criteria_micro_ids =
                  response.evaluation_criterias_micro;
                this.key_evaluation_criteria++;
              });
          });
      } else if (evaluation) {
        this.fetchEvaluationCriteriaFromScope();
      }
    },
    fetchEvaluationCriteriaFromScope() {
      const eval_data = this.evaluation;
      if (!eval_data || !eval_data.scope_id) return;

      const fetchForMatter = (matter_id) => {
        if (this.institution && this.institution.show_competence_unit)
          this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
            matter__id: matter_id,
          });
        this.$store.dispatch(names.FETCH_STUDY_UNITS, matter_id);
        this.$store
          .dispatch(names.FETCH_EVALUATION_CRITERIAS, {
            matter_id: matter_id,
          })
          .then((evaluation_criterias) => {
            this.evaluation_criteria_micro_ids = evaluation_criterias.map(
              (x) => x.id
            );
            this.key_evaluation_criteria++;
          });
      };

      if (eval_data.scope == 1) {
        // Scope: Section → get matter from section or egress_profile_matter
        this.$store
          .dispatch(names.FETCH_SECTION, eval_data.scope_id)
          .then((section) => {
            if (section && section.matter) {
              fetchForMatter(section.matter);
            } else if (section && section.egress_profile_matter) {
              this.$store
                .dispatch(
                  names.FETCH_EGRESS_PROFILE_MATTER,
                  section.egress_profile_matter
                )
                .then((egr_matter) => {
                  if (egr_matter && egr_matter.matter) {
                    fetchForMatter(egr_matter.matter);
                  }
                });
            }
          });
      } else if (eval_data.scope == 2) {
        // Scope: Matter directly
        fetchForMatter(eval_data.scope_id);
      } else if (eval_data.scope == 3) {
        // Scope: Egress Profile Matter → get matter from EPM
        this.$store
          .dispatch(names.FETCH_EGRESS_PROFILE_MATTER, eval_data.scope_id)
          .then((egr_matter) => {
            if (egr_matter && egr_matter.matter) {
              fetchForMatter(egr_matter.matter);
            }
          });
      }
    },
    fetchStudyUnitAndEvaluationCriteria(matter_id) {
      if (this.institution && this.institution.show_competence_unit)
        this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
          matter__id: matter_id,
        });
      this.$store.dispatch(names.FETCH_STUDY_UNITS, matter_id);
      this.$store.dispatch(names.FETCH_EVALUATION_CRITERIAS, {
        matter_id: matter_id,
      });
    },
    changeStateEvaluation() {
      const payload = {
        new_evaluation_id: this.evaluation.id,
        item: {
          is_locked: !this.evaluation.is_locked,
        },
      };
      this.$store.dispatch(names.PATCH_NEW_EVALUATION, payload);
    },
    printRubric() {
      this.isPrintingRubrica = true;
      this.$nextTick(() => {
        window.print();
        this.isPrintingRubrica = false;
      });
    },
    //Metodos Nuevos Formatos
    firstFormatWrittenExamDuoc() {
      this.first_format_written_exam_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.first_format_written_exam_duoc = false;
      });
    },
    secondFormatWrittenExamDuoc() {
      this.second_format_written_exam_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.second_format_written_exam_duoc = false;
      });
    },
    thirdFormatEPEDuoc() {
      this.third_format_epe_duoc = true;
      this.isfullImpressionEvaluation = true;
      this.$nextTick(() => {
        window.print();
        this.third_format_epe_duoc = false;
        this.isfullImpressionEvaluation = false;
      });
    },
    fourthFormatEPEDuoc() {
      this.fourth_format_epe_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.fourth_format_epe_duoc = false;
      });
    },
    fifthFormatEPEDuoc() {
      this.fifth_format_correct_answer_rubric_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.fifth_format_correct_answer_rubric_duoc = false;
      });
    },
    sixthFormatFormativeDuoc() {
      this.sixth_format_formative_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.sixth_format_formative_duoc = false;
      });
    },
    seventhFormatEvaPartialDuoc() {
      this.seventh_format_eva_partial_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.seventh_format_eva_partial_duoc = false;
      });
    },
    eighthFormatEvaPartialDuoc() {
      this.eighth_format_eva_partial_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.eighth_format_eva_partial_duoc = false;
      });
    },
    ninethFormatWrittenPartialDuoc() {
      this.nineth_format_written_partial_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.nineth_format_written_partial_duoc = false;
      });
    },
    tenthFormatWrittenPartialDuoc() {
      this.tenth_format_written_partial_duoc = true;
      this.$nextTick(() => {
        window.print();
        this.tenth_format_written_partial_duoc = false;
      });
    },
    fullImpressionEvaluation() {
      this.isfullImpressionEvaluation = true;
      this.$nextTick(() => {
        window.print();
        this.isfullImpressionEvaluation = false;
      });
    },
    // viewOutputFormat(view_value = null) {
    //   this.view_output_format = view_value;
    //   this.$nextTick(() => {
    //     window.print();
    //     this.view_output_format = null;
    //   });
    // },
    printInstrument() {
      this.isPrintingInstrumento = true;
      this.$nextTick(() => {
        window.print();
        this.isPrintingInstrumento = false;
      });
    },
    previewEvaluation() {
      this.preview_evaluation = !this.preview_evaluation;
    },
    isFetchCompleted() {
      this.fetch_completed = true;
    },
    fetchTrimmedSecMatEPM() {
      this.$restful
        .Get(`/teaching/get_trimmed_sections_matters_and_epms/`)
        .then((response) => {
          this.sections = response.sections;
          this.matters = response.matters;
          this.egress_profile_matters = response.egress_profile_matters;
        });
    },
    pushDashboard() {
      this.$swal
        .fire({
          backdrop: `rgba(0,0,0,0.99)`,
          title: this.$t("evaluations.newEvaluations.accessDenied"),
          text: this.$t("evaluations.newEvaluations.noPermissionForAction"),
          type: "warning",
          showConfirmButton: false,
          timer: 5000, // Tiempo del temporizador en milisegundos (5000 ms = 5 segundos)
          timerProgressBar: true,
          willClose: () => {
            this.$router.push({ name: "DashboardView" });
          },
        })
        .then(() => {
          this.$router.push({ name: "DashboardView" });
        });
    },
    fetchEvaluationSituations() {
      this.$restful.GetAll(`/teaching/evaluation-situation/`).then((response) => {
        this.evaluation_situations = response;
      });
    },
    createdInstrument(instrument_id) {
      this.$bvModal.hide(`modal-created-instrument`);
      if (instrument_id != null)
        this.$store.dispatch(names.FETCH_NEW_TEST_EVALUATION_CRITERIA_MICROS, {
          test_id: instrument_id,
        });
    },
    fetchAvailableSectionToReplicateEvaluation() {
      if (!this.evaluator_view && !this.evaluatee_view) {
        if (this.evaluation && [2, 3].includes(this.evaluation.scope)) {
          this.$restful
            .Post(
              `/evaluations2/available_sections_to_replicate_evaluation/?evaluation=${this.evaluation.id}`
            )
            .then((response) => {
              this.available_sections_to_replicate_evaluation = [
                { id: "all", name: this.$t("evaluations.newEvaluations.all") },
                ...response,
              ];
            });
        }
      }
    },
    fetchAvailableSectionEvaluationToReplicateEvaluation() {
      if (!this.evaluator_view && !this.evaluatee_view) {
        if (this.evaluation && [1].includes(this.evaluation.scope)) {
          this.$restful
            .Get(
              `/evaluations2/available_sections_to_replicate_section_evaluation/?evaluation_id=${this.evaluation.id}`
            )
            .then((response) => {
              this.available_sections_to_replicate_section_evaluation = [
                { id: "all", name: this.$t("evaluations.newEvaluations.all") },
                ...response,
              ];
            });
        }
      }
    },
    // El estudiante finalizó un instrumento: revisa si hay otro pendiente para
    // que continúe respondiéndolo sin tener que buscarlo manualmente.
    isInstrumentFinishedByEvaluatee(test_id) {
      const evaluatee_test = this.evaluatee_tests.find(
        (x) => x.evaluatee == this.user.id && x.test == test_id
      );
      return !!(
        evaluatee_test &&
        (evaluatee_test.finished_at || evaluatee_test.is_published)
      );
    },
    // El estudiante solo puede iniciar el instrumento dentro de su ventana
    // [start_time, end_time]; fuera de ella no tiene sentido redirigirlo.
    isInstrumentAvailableNow(test) {
      if (!test || test.start_time == null || test.end_time == null)
        return false;
      const now = this.$moment();
      return (
        now >= this.$moment(test.start_time) &&
        now <= this.$moment(test.end_time)
      );
    },
    goToNextPendingInstrument(finished_test_id) {
      if (!this.evaluatee_view) return;
      // Espera a que el store refleje el instrumento recién finalizado antes de
      // calcular cuál es el siguiente pendiente.
      this.$nextTick(() => {
        const tests = this.testFilter;
        if (tests.length <= 1) return;
        let next_index = -1;
        // Busca a partir del tab actual (con wrap) el siguiente sin finalizar,
        // excluyendo el instrumento recién finalizado.
        for (let offset = 1; offset <= tests.length; offset++) {
          const index = (this.tabIndex + offset) % tests.length;
          if (
            tests[index].id != finished_test_id &&
            !this.isInstrumentFinishedByEvaluatee(tests[index].id) &&
            this.isInstrumentAvailableNow(tests[index])
          ) {
            next_index = index;
            break;
          }
        }
        if (next_index == -1) return;
        const next_test = tests[next_index];
        const entity = this.$getVisibleNames(
          "evaluations2.test",
          false,
          "Instrumento"
        );
        this.$swal({
          title: `<p>${this.$t(
            "evaluations.newEvaluations.instrumentFinishedTitle",
            { entity }
          )}</p>`,
          html: this.$t("evaluations.newEvaluations.anotherInstrumentAvailable", {
            entity: entity.toLowerCase(),
            title: next_test.title,
          }),
          type: "info",
          showCancelButton: true,
          confirmButtonText: this.$t(
            "evaluations.newEvaluations.goToNextInstrument",
            { entity: entity.toLowerCase() }
          ),
          cancelButtonText: this.$t("reusable.common.close"),
        }).then((result) => {
          if (result.value) {
            if (!this.openTabsIndex.includes(next_index))
              this.openTabsIndex.push(next_index);
            this.tabIndex = next_index;
          }
        });
      });
    },
  },
  mounted() {},
  watch: {
    tabIndex() {
      if (!this.openTabsIndex.includes(this.tabIndex))
        this.openTabsIndex.push(this.tabIndex);
    },
    evaluator_check_section(value) {
      if (
        !value &&
        !this.evaluator_check_evaluation &&
        !this.evaluator_check_tests &&
        this.evaluator_view
      )
        this.pushDashboard();
    },
    evaluator_check_evaluation(value) {
      if (
        !value &&
        !this.evaluator_check_section &&
        !this.evaluator_check_tests &&
        this.evaluator_view
      )
        this.pushDashboard();
    },
    evaluator_check_tests(value) {
      if (
        !value &&
        !this.evaluator_check_section &&
        !this.evaluator_check_evaluation &&
        this.evaluator_view
      )
        this.pushDashboard();
    },
    // Si se selecciona el Todos se quita del arreglo y se hace uno nuevo con las opciones
    selected_section_ids(option) {
      if (option.includes("all")) {
        this.selected_section_ids =
          this.available_sections_to_replicate_evaluation
            .filter((x) => x.id != "all" && x.evaluation_exists == false)
            .map((y) => y.id);
      }
    },
    // Si se selecciona el Todos se quita del arreglo y se hace uno nuevo con las opciones
    selected_section_evaluation_ids(option) {
      if (option.includes("all")) {
        this.selected_section_evaluation_ids =
          this.available_sections_to_replicate_section_evaluation
            .filter((x) => x.id != "all")
            .map((y) => y.id);
      }
    },
  },
  created() {
    this.fetchAvailableSectionToReplicateEvaluation();
    this.fetchAvailableSectionEvaluationToReplicateEvaluation();
    this.fetchEvaluationSituations();
    this.$store.dispatch(names.FETCH_MULTIPLE_CHOICE_QUESTION_SUB_TYPES);
    this.$store
      .dispatch(names.FETCH_NEW_EVALUATION, {
        evaluation_id: this.evaluation_id,
        forceFetch: true,
      })
      .then((response) => {
        if (
          this.evaluator_view &&
          this.user &&
          !response.evaluators.includes(this.user.id) &&
          !this.user.is_superuser &&
          !this.user.group_names.includes(
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
          )
        )
          this.evaluator_check_evaluation = false;
        if (response && response.scope == 1 && response.scope_id != null) {
          this.$store
            .dispatch(names.FETCH_SECTION, response.scope_id)
            .then((section) => {
              if (
                this.evaluator_view &&
                this.user &&
                !section.professors.includes(this.user.id) &&
                !this.user.is_superuser &&
                !this.user.group_names.includes(
                  "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
                )
              )
                this.evaluator_check_section = false;
            });
          // Se buscan todas las secciones del profesor para poder aplicar el funcionamiento del
          // replicateTests para replicar multiples instrumentos en varias evaluaciones de distinta sección
          // pero del mismo parent_evaluation.
          if (!this.evaluator_view && !this.evaluatee_view && this.user)
            this.$store.dispatch(names.FETCH_SECTIONS, {
              professor_id: this.user.id,
            });
        }
        // El estudiante no llama a la evaluación padre; sus criterios se resuelven desde el scope de la propia evaluación
        if (response.parent_evaluation != null && !this.evaluatee_view) {
          this.$store
            .dispatch(names.FETCH_NEW_EVALUATION, response.parent_evaluation)
            .then((evaluation_parent) => {
              this.fetchMatterEvaluation(evaluation_parent);
            });
        } else this.fetchMatterEvaluation(response);
        if ([1, 2, 3].includes(response.scope)) this.fetchTrimmedSecMatEPM();
        else if (response.scope == 4)
          this.$store.dispatch(names.FETCH_EGRESS_PROFILES);
        else if (response.scope == 5) this.$store.dispatch(names.FETCH_CAREERS);
        else if (response.scope == 6)
          this.$store.dispatch(names.FETCH_FACULTIES);
        else if (response.scope == 7)
          this.$store.dispatch(names.FETCH_CAMPUSES);
      });
    this.$store
      .dispatch(names.FETCH_NEW_TESTS, {
        evaluation_id: this.evaluation_id,
      })
      .then((response) => {
        const tests_ids = response.map((x) => x.id);
        const evaluatee_ids = [
          ...new Set(response.map((x) => x.evaluatees).flat()),
        ];
        this.$store.dispatch(names.FETCH_ALT_USERS, {
          user_ids: evaluatee_ids,
        });
        this.$store.dispatch(names.FETCH_NEW_RUBRIC_INSTRUMENTS, {
          tests_ids: tests_ids,
        });
        if (
          (!this.evaluatee_view && !this.evaluator_view) ||
          (!this.evaluatee_view && this.evaluator_view)
        ) {
          this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
            evaluatees_ids: evaluatee_ids,
            tests_ids: tests_ids,
          });
        }
        this.$store.dispatch(names.FETCH_NEW_TEST_EVALUATION_CRITERIA_MICROS, {
          tests_ids: tests_ids,
        });
        this.$store.dispatch(names.FETCH_NEW_TEST_GROUPS, {
          tests_ids: tests_ids,
        });
        if (
          this.evaluator_view &&
          this.user &&
          response.filter((x) => x.evaluators.includes(this.user.id)).length ==
            0 &&
          !this.user.is_superuser &&
          !this.user.group_names.includes(
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
          )
        )
          this.evaluator_check_tests = false;
        if (this.instrument_id) {
          const index = response.findIndex((x) => x.id == this.instrument_id);
          if (index != -1) this.tabIndex = index;
        } else if (response && response.length > 0) this.tabIndex = 0;
      });
    if (!this.evaluatee_view && !this.evaluator_view) {
      this.$store.dispatch(names.FETCH_EVALUATEE_EVALUATIONS, {
        evaluation_id: this.evaluation_id,
      });
    }
  },
};
</script>

<style scoped>
.div-href {
  color: #007bff;
}
.div-href:hover {
  color: #0057b1 !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-new-documents {
  display: flex;
  text-align: left;
}
.spinner-tab {
  margin-bottom: 2px;
}
.container-add-instrument {
  display: flex;
  align-items: center;
}
.add-new-instrument {
  max-height: 31px;
}
.lock-btn {
  border: 1px;
  height: 27px;
  width: 27px;
}
.container-btn-print {
  display: flex;
  justify-content: right;
}
.btn-preview-evaluation,
.btn-preview-evaluation-no-edit {
  display: flex;
  justify-content: right !important;
}
.badge-profile {
  background: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
}
.title-presentation {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  color: black;
  margin-top: 5px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  /* Columna para que el badge de idioma quede debajo del título. */
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
}
.container-matter-language {
  display: flex;
  justify-content: center;
  align-items: center;
}
.matter-language-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  border: 1px solid #f5a623;
  border-radius: 999px;
  background: #fff8ec;
  color: #16263b;
  font-size: 0.65rem;
  font-weight: 600;
  text-shadow: none;
  vertical-align: middle;
}
.matter-language-badge_flag {
  width: 16px;
  height: auto;
  border-radius: 2px;
  flex-shrink: 0;
}
.container-buttons-evaluation {
  display: flex;
  justify-content: space-between;
  margin-top: 1.2em;
  margin-bottom: 0.5em;
}
.btn-is-locked-activate {
  display: flex;
  justify-content: right;
}
.container-buttons-instrument {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.lock-instrument-right {
  display: flex;
  justify-content: right !important;
}
.card {
  border-radius: 0 !important;
}
.tabs-instrument {
  transition: all 0.3s ease;
  border: none;
}
.card-body {
  padding: 5px;
}
.link-span {
  cursor: pointer;
  color: #007bff;
}
.link-span:hover {
  background: #007bff;
  color: white;
}
.b-dropdown-form {
  padding: 0;
}
.page-break {
  page-break-before: always;
  page-break-after: auto;
  page-break-inside: avoid;
}
@media print {
  .container-instrument {
    border: none;
  }
  .print-hide {
    display: none !important;
  }
  .print-show {
    display: block !important;
  }
  .container-buttons-evaluation {
    margin-top: 0;
  }
  /* Oculta los tabs al momento de imprimir */
  .tabs >>> ul {
    display: none !important;
  }
}
@media (max-width: 750px) {
  .title-presentation {
    display: flex;
    flex-direction: column;
    vertical-align: middle;
  }
}
</style>
